import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Popup from "./tableComponenets/Popup";
import ViewMore from "./tableComponenets/ViewMore";
import { PaginationSection } from "views/CompanyDirectory/components";
import fields from "./TableData";
import { addVendorsToRfq } from "actions/rfqActions";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "./tableComponenets/Drawer";
import BusinessInfoDrawer from "./tableComponenets/BusinessInfoDrawer";
import rfqService from "services/rfqService";
import Loading from "components/Loading";
import {
  CLEAR_NETWORK_FILTERS,
  neevayNetworkFilteredSearch,
  searchByPage,
} from "actions/searchActions";
import { getSelectedFacetString, updateSearchFilter } from "utils/searchUtils";
// import { withStyles } from "@mui/styles";
import { Tooltip, Snackbar } from "@mui/material";
import { withStyles } from "@material-ui/core";
import ServiceOffered from "./tableComponenets/ServiceOffered";
import StaticPopup from "components/StaticPopup";
import { addVendorInCompanyDirectory } from "actions/companyDirectoryActions";
import Alert from '@mui/material/Alert';
import SelectedVendorsDrawerNN from "./tableComponenets/SelectedVendorsDrawerNN";
import { fetchContactViewStatus, hideContactDetails } from "actions/businessActions";
import axios from "utils/axios";
import AddCategoryPopUp from "views/CompanyDirectory/components/AddCategoryPopUp";
import businessService from "services/businessService";

const CustomTooltip = withStyles({
  tooltip: {
    // backgroundColor: "#fff", // Change the background color here
    // color: "#000",
    // fontSize: "20px", // Change the text size here
  },
})(Tooltip);



const getColumnWidthClass = (fieldKey) => {
  if (fieldKey === "clientNames") return "w-[240px] min-w-[240px]";
  if (fieldKey === "addresses_city") return "w-[180px] min-w-[180px]";
  if (fieldKey === "annualTurnOver") return "w-[180px] min-w-[180px]";
  return "min-w-[120px]";
};

const getClassName = (index, fieldsLength, fieldKey) => {
  let className =
    `sticky top-0 z-[5] ${getColumnWidthClass(fieldKey)} border-b border-gray-200 bg-gray-50 px-4 py-3 text-left font-medium text-[#374151]`;
  if (index === fieldsLength - 1) {
    className += " rounded-tr-md ";
  }
  return className;
};



const normalizeRecommendedMarketplaceVendor = (vendor = {}) => ({
  ...vendor,
  supplierId: vendor.supplierId,
  businessName: Array.isArray(vendor.businessName)
    ? vendor.businessName
    : [vendor.businessName || vendor.Company || "Unnamed vendor"],
  businessEmail: vendor.businessEmail || vendor?.contactDetails?.[0]?.email || "",
  businessMobileNumber: vendor.businessMobile || vendor.businessMobileNumber || vendor?.contactDetails?.[0]?.mobile || "",
  businessEmailNumber: vendor.businessEmail || vendor?.contactDetails?.[0]?.email || "",
  owners: Array.isArray(vendor.owners) ? vendor.owners : [],
  subscriptionType: vendor.subscriptionType || (vendor.isPremium ? "PREMIUM" : ""),
});

const getMarketplaceVendorKey = (vendor = {}) =>
  String(vendor?.supplierId || vendor?.id || vendor?._id || "");

const getSelectionSnapshotKey = (vendors = []) =>
  vendors
    .map(getMarketplaceVendorKey)
    .filter(Boolean)
    .sort()
    .join("|");

const Table = ({
  isSliderView = false,
  rfqId,
  handleSliderClose,
  invitedVendors,
  maxLimit,
  preselectedVendors = [],
  selectionOnly = false,
  onSelectionChange,
  showFilters = false,
  onToggleFilters = null,
  toolbarSummaryPortalTarget = null,
  toolbarActionsPortalTarget = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const user = auth?.user;
  const contactLimit = user?.userEntity?.limits?.viewContacts || 25;
  const viewedSupplierIds = useSelector((state) => state.business.viewedSupplierIds) || [];
  const contactViewed = viewedSupplierIds.length;
  const hasLimitReached = useSelector((state) => state.business.hasLimitReached);

  const searchResult = useSelector((state) => state.search);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openBusinessInfoDrawer, setOpenBusinessInfoDrawer] = useState(false);
  const [addVendorsLoader, setAddVendorsLoader] = useState(false);
  const [businessInfo, setBusinessInfo] = useState({});
  const [showAddVendorPopup, setShowAddVendorPopup] = useState(false);
  const [showAddCategoryPopup, setShowAddCategoryPopup] = useState(false);
  const [addNewVendorError, setAddNewVendorError] = useState(false);
  const [addVendorWithTagsLoading, setAddVendorWithTagsLoading] = useState(false);
  const [addCategoryError, setAddCategoryError] = useState({
    status: false,
    message: "",
  });
  const [tagVendor, setTagVendor] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [revealedContacts, setRevealedContacts] = useState({});
  const [revealedEmails, setRevealedEmails] = useState({});
  const [exceptionSuppliers, setExceptionSuppliers] = useState([]);
  const hasSelectionSyncStarted = useRef(false);
  const appliedPreselectedSnapshotRef = useRef("");

  const remainingLimit = maxLimit - invitedVendors?.length - selectedRows.length;

  // const totalPages = Math.ceil(totalItems / itemsPerPage);

  const userId = user?.userId;
  const userName = user?.name;
  const userEmail = user?.email;
  const entityId = user?.userEntity?.entityId;
  const senderEmail = user?.userEntity?.senderEmail;
  const directoryName = user?.userEntity?.directoryName;
  const searchKeyWord = searchResult?.searchKeyWord ?? "";
  const regionString = searchResult?.regionString ?? "pan india";
  const showRegionInSummary = regionString && !["pan india", "pan-india"].includes(regionString.toLowerCase());
  const searchType = searchResult?.searchType ?? "";
  const selectedFacets = searchResult?.selectedFacets;
  const start = searchResult?.start ?? 0;
  const data = searchResult.results ?? [];
  const loading = searchResult?.isSearching;
  const totalItems = searchResult?.numFound;
  const itemsPerPage = 0;
  const MAX_SELECTION_RFQ = 15;
  const totalPages = totalItems > 60 ? Math.ceil(totalItems / 60) : 1;
    // const isRestrictionEnabled = isSliderView && entityId === "ent_1";
  const isRestrictionEnabled = false;
  const baseFilterStr = searchResult?.baseFilterStr || "";
  const resultLabel = searchResult?.subCategory || searchResult?.searchKeyWord || "selected search";
  const activeFilterFacets = (selectedFacets || []).filter(
    (facet) => facet?.facet !== "Category" && facet?.facet !== "Sub Category"
  );
  const hasActiveUserFilters = activeFilterFacets.some((facet) => facet?.values?.length);

  const getNetworkQueryFilterString = (facets = []) => {
    const queryFacets = baseFilterStr
      ? facets.filter((facet) => facet?.facet !== "Category" && facet?.facet !== "Sub Category")
      : facets;

    return getSelectedFacetString(queryFacets || []);
  };

  const chipFilterValue = (facet, value) => {
    if (facet === "GST Certified") return `GST: ${value === "true" ? "Yes" : "No"}`;
    if (facet === "Subscription Type") return "Promoted Profiles";
    if (facet === "Is Projects") return `Past Project: ${value === "true" ? "Yes" : "No"}`;
    if (facet === "Is Clients") return `Past Clients: ${value === "true" ? "Yes" : "No"}`;
    return value;
  };

  const handleRemoveNetworkFilter = (facetTitle, facetValue) => {
    const filterSet = updateSearchFilter(selectedFacets || [], facetTitle, facetValue, false);
    const filterStr = getNetworkQueryFilterString(filterSet);

    dispatch(
      neevayNetworkFilteredSearch({
        searchKeyWord,
        regionString,
        filterStr,
        facetTitle,
        facetValue,
        isSelected: false,
        searchType,
        baseFilterStr,
      })
    );
  };

  const handleClearNetworkFilters = () => {
    dispatch({ type: CLEAR_NETWORK_FILTERS });
    dispatch(
      neevayNetworkFilteredSearch({
        searchKeyWord,
        regionString,
        filterStr: "",
        facetTitle: "",
        facetValue: "",
        isSelected: false,
        searchType,
        baseFilterStr,
      })
    );
  };

  const handleTryPanIndia = () => {
    const filterStr = [baseFilterStr, getNetworkQueryFilterString(selectedFacets || [])]
      .filter(Boolean)
      .join(" AND ");

    dispatch(searchByPage(searchKeyWord, "Pan India", filterStr, searchType || "all", 1));
  };

  useEffect(() => {
    if (!isSliderView) return;

    const normalizedPreselected = (preselectedVendors || []).map(normalizeRecommendedMarketplaceVendor);
    const snapshotKey = getSelectionSnapshotKey(normalizedPreselected);

    if (appliedPreselectedSnapshotRef.current === snapshotKey) return;
    if (hasSelectionSyncStarted.current && snapshotKey) return;

    appliedPreselectedSnapshotRef.current = snapshotKey;
    setSelectedRows(normalizedPreselected);
  }, [isSliderView, preselectedVendors]);

  useEffect(() => {
    if (selectionOnly) {
      if (!hasSelectionSyncStarted.current) {
        hasSelectionSyncStarted.current = true;
        if (!selectedRows.length) return;
      }
      appliedPreselectedSnapshotRef.current = getSelectionSnapshotKey(selectedRows);
      onSelectionChange?.(selectedRows);
    }
  }, [onSelectionChange, selectedRows, selectionOnly]);

  const handleInputChange = (e) => {
    setTagVendor(e.target.value);
  };

  const componentRegistry = (
    component,
    handleOpenBusinessInfoDrawerOpen,
    props
  ) => {
    // console.log("this is a component 999999999", props);
    switch (component) {
      case "Popup":
        return <Popup {...props} />;
      case "ServicePopup":
        return <ServiceOffered values={props.values} title={props.title} />;
      case "ViewMore":
        return <ViewMore values={props.values} title={props.title} />;
      case "Drawer":
        return (
          <Drawer
            values={props.vendor}
            handleOpenBusinessInfoDrawerOpen={handleOpenBusinessInfoDrawerOpen}
          />
        );
      case "ContactButton":
        return (
          <ContactButton
            vendor={props.vendor}
            isRevealed={props.isContactRevealed}
            onReveal={handleViewContact}
          />

        );

      case "EmailButton":
        return (
          <EmailButton
            vendor={props.vendor}
            isRevealed={props.isEmailRevealed}
            onReveal={handleViewContact}
          />

        );

      default:
        return (
          <span className="text-gray-500 font-medium">
            {props.title?.toUpperCase() === "GST STATUS"
              ? props.values == "true"
                ? "Active"
                : "Inactive"
              : props.title?.toUpperCase() === "WEBSITE"
                ? props.values.length > 0 ? (
                  <a
                    href={props.values}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0057D9] transition hover:text-[#003F9E] hover:underline"
                  >
                    {props.values}
                  </a>
                ) : (
                  <span>--</span>
                )
                : props?.values?.length > 0
                  ? props.values
                  : "--"}
          </span>
        );
    }
  };

  // Handle contact view with daily limit
  const handleViewContact = async (vendor) => {
    const sid = vendor.supplierId;

    // 1. Already viewed → reveal without API call
    if (revealedContacts[sid]) {
      return;
    }

    // 2. Limit reached
    if (hasLimitReached || contactViewed >= contactLimit) {
      setSnackbarSeverity("error");
      setSnackbarMessage(`You have reached your daily contact limit of ${contactLimit}.`);
      setSnackbarOpen(true);
      return;
    }

    // 3. API call
    const supplierDetails = { supplierId: sid };
    await dispatch(hideContactDetails(userId, supplierDetails, entityId));

    // 4. Reveal locally
    setRevealedContacts(prev => ({ ...prev, [sid]: true }));
    setRevealedEmails(prev => ({ ...prev, [sid]: true }));
  };


  const ContactButton = ({ vendor, isRevealed, onReveal }) => {
    if (isRevealed) {
      return <div className="text-gray-700 font-medium">{vendor.businessMobileNumber || "--"}</div>;
    }
    return (
      <button
        onClick={() => onReveal(vendor)}
        className="text-left hover:text-orange-600 text-xs transition-colors hover:underline"
      >
        View Contact
      </button>
    );
  };


  const EmailButton = ({ vendor, isRevealed, onReveal }) => {
    if (isRevealed) {
      return <div className="text-gray-700 font-medium">{vendor.businessEmail || "--"}</div>;
    }
    return (
      <button
        onClick={() => onReveal(vendor)}
        className="text-left hover:text-orange-600 text-xs transition-colors hover:underline"
      >
        View Email
      </button>
    );
  };

const fetchSupplierExceptions = async () => {
  try {
    const res = await axios.get(
      `/api/supplier/exceptions?entityId=${entityId}`
    );

    setExceptionSuppliers(res?.data?.data || []);
  } catch (err) {
    console.error("Exception supplier fetch failed", err);
  }
};

useEffect(() => {
  if (isRestrictionEnabled) {
    fetchSupplierExceptions();
  }
}, [isRestrictionEnabled]);

const isVendorSelectable = (vendor) => {

  // Restriction ONLY for ent_1 slider flow
  if (!isRestrictionEnabled) return true;

  return (
    vendor?.subscriptionType === "PREMIUM" ||
    exceptionSuppliers.includes(Number(vendor?.supplierId))
  );
};


  const handlePageChange = (pageNum) => {
    setCurrentPage(pageNum);
    const filterStr = [baseFilterStr, getNetworkQueryFilterString(selectedFacets || [])]
      .filter(Boolean)
      .join(" AND ");
    dispatch(
      searchByPage(searchKeyWord, regionString, filterStr, searchType || "all", pageNum)
    );
    // dispatch(searchCompanyDirectoryVendor({ searchKey: searchValue, pageNum }));
  };

  const handleSelectRow = (e, rowData) => {
    if (!isVendorSelectable(rowData)) return;
    const rowKey = getMarketplaceVendorKey(rowData);
    if (!rowKey) return;

    // if selecting for RFQ enforce max limit
    if (isSliderView) {
      if (e.target.checked) {
        // trying to add
        if (invitedVendors?.length + selectedRows.length >= maxLimit) {
          setSnackbarSeverity('error');
          setSnackbarMessage(`Vendor limit reached. Maximum ${maxLimit} vendors allowed.`);
          setSnackbarOpen(true);
          return;
        }

        setSelectedRows((currentRows) => {
          const isAlreadySelected = currentRows.some(
            (selectedRow) => getMarketplaceVendorKey(selectedRow) === rowKey
          );

          return isAlreadySelected ? currentRows : [...currentRows, rowData];
        });

      } else {
        setSelectedRows((currentRows) =>
          currentRows.filter(
            (selectedRow) => getMarketplaceVendorKey(selectedRow) !== rowKey
          ),
        );
      }
    } else {
      if (e.target.checked) {
        setSelectedRows((currentRows) => {
          const isAlreadySelected = currentRows.some(
            (selectedRow) => getMarketplaceVendorKey(selectedRow) === rowKey
          );

          return isAlreadySelected ? currentRows : [...currentRows, rowData];
        });
      } else {
        setSelectedRows((currentRows) =>
          currentRows.filter(
            (selectedRow) => getMarketplaceVendorKey(selectedRow) !== rowKey
          ),
        );
      }
    }
  };

  const handleClickAddToCompanyDirectory = () => {
    if (!isSliderView && selectedRows.length > 0) {
      setAddCategoryError({ status: false, message: "" });
      setShowAddCategoryPopup(true);
    }
  };

  // const handleAddVendorToCD   = async () => {
  //   const supplierIds = selectedRows.map((supplier) => supplier?.supplierId);
  //   // const vendorTags = tagVendor.split(/[ ,]+/);
  //   const payload = {
  //     entityId: entityId,
  //     neevaySupplierIds: supplierIds,
  //     userId: userId,
  //     userName: userName,
  //     // tags: vendorTags ?? [],
  //   };
  //   const response = await dispatch(addVendorInCompanyDirectory(payload));
  //   console.log("FFFFFF", response);
  //   setShowAddVendorPopup(false);
  //   setSelectedRows([]);
  //   setAddVendorWithTagsLoading(false);
  //   setTagVendor("");
  // };

  const handleAddVendorToCD = async (vendorCategories = []) => {
    if (!Array.isArray(vendorCategories) || vendorCategories.length === 0) {
      setAddCategoryError({
        status: true,
        message: "Please select at least one category before adding vendors.",
      });
      return;
    }

    setAddVendorWithTagsLoading(true); // Start loading
    const supplierIds = selectedRows.map((supplier) => supplier?.supplierId);
    const payload = {
      entityId: entityId,
      neevaySupplierIds: supplierIds,
      userId: userId,
      userName: userName,
      vendorCategories,
    };

    setAddVendorWithTagsLoading(true);

    try {
      const response = await dispatch(addVendorInCompanyDirectory(payload));
      

      if (!response.error) {
        // Success: Show success snackbar with added and existing vendors
        const { existingVendors, savedVendors } = response.vendorData;
        let successMessage = "Vendor added successfully";

        // if (savedVendors.length > 0) {
        //     successMessage += ` Added: ${savedVendors.join(', ')}.`;
        // }

        // if (existingVendors.length > 0) {
        //     successMessage += ` Existing: ${existingVendors.join(', ')}.`;
        // }

        setSnackbarSeverity('success');
        setSnackbarMessage(successMessage);
      } else {
        // Error: Show error snackbar with the error message
        setSnackbarSeverity('error');
        setSnackbarMessage('Failed to add vendor');
      }

    } catch (error) {
      // Handle unexpected errors
      console.error("Error in handleAddVendorToCD:", error);
      setSnackbarSeverity('error');
      setSnackbarMessage('An unexpected error occurred.');
    } finally {
      setAddVendorWithTagsLoading(false); // Stop loading
      setSnackbarOpen(true);
      setShowAddCategoryPopup(false);
      setSelectedRows([]);
      setAddVendorWithTagsLoading(false);
      setTagVendor("");
      setAddCategoryError({ status: false, message: "" });
    }
  };


  const handleOpenBusinessInfoDrawerOpen = async (values) => {
    setOpenBusinessInfoDrawer(true);
    setBusinessInfo(values);

    const hasVendorCategories =
      Array.isArray(values?.vendorCategories) && values.vendorCategories.length > 0;
    const hasProjectDetails =
      Array.isArray(values?.projects) &&
      values.projects.some(
        (project) =>
          project &&
          typeof project === "object" &&
          (project?.description || project?.location || project?.clientName),
      );

    if (hasVendorCategories && hasProjectDetails) {
      return;
    }

    try {
      const payload = await businessService.fetchBusinessById(values?.supplierId);
      const vendorCategories = hasVendorCategories
        ? values.vendorCategories
        : payload?.profile?.vendorCategories || [];
      const projects = hasProjectDetails
        ? values.projects
        : payload?.projects?.projects || [];

      if (vendorCategories.length > 0 || projects.length > 0) {
        setBusinessInfo((previousInfo) => ({
          ...previousInfo,
          vendorCategories,
          projects,
        }));
      }
    } catch (error) {
      console.error("Failed to fetch marketplace vendor categories", error);
    }
  };

  const handleOpenBusinessInfoDrawerClose = () => {
    setOpenBusinessInfoDrawer(false);
    setBusinessInfo({});
  };

  const handleSelectedVendorsClick = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleAddVendorsToRfq = async () => {
    if (invitedVendors?.length + selectedRows.length > maxLimit) {
      setSnackbarSeverity("error");
      setSnackbarMessage(`Cannot invite more than ${maxLimit} vendors for this RFQ.`);
      setSnackbarOpen(true);
      return;
    }

    if (isSliderView) {
      if (selectedRows.length > MAX_SELECTION_RFQ) {
        setSnackbarSeverity('error');
        setSnackbarMessage(`Please select up to ${MAX_SELECTION_RFQ} vendors for RFQ`);
        setSnackbarOpen(true);
        return;
      }
    }
    setAddVendorsLoader(true);
    if (isSliderView) {
      try {
        const suppliers = await Promise.all(
          selectedRows?.map(async (row) => {
            const usersContactDataPromises = row?.owners?.map((userId) =>
              rfqService.getUserContacts({ userId }).catch((error) => {
                console.error("Error fetching user details:", error);
                return { error: true, message: error.message };
              })
            );

            const usersContactData = await Promise.all(
              usersContactDataPromises
            );

            const contacts = usersContactData.map((contact) => {
              if (contact.error) {
                console.error("Error fetching user details:", contact.message);
                return {};
              }
              return {
                mobile: contact.user?.mobile,
                email: contact.user?.email,
                name: contact.user?.name,
              };
            });
            const contactDetails = [
              ...contacts,
              {
                mobile: row?.businessMobileNumber,
                email: row?.businessEmail,
                name: "user",
              },
            ];
            const uniqueArrayOfObjects = contactDetails?.reduce((acc, obj) => {
              const existingEmail = acc.find(
                (item) => item.email === obj.email
              );
              if (!existingEmail) {
                acc.push(obj);
              }
              return acc;
            }, []);
            const supplierObj = {
              supplierId: row?.supplierId.toString(),
              businessName: row?.businessName?.join(),
              isNeevayVendor: true,
              isPremium: row?.subscriptionType === "PREMIUM",
              contactDetails: uniqueArrayOfObjects.filter(
                (item) => Object.keys(item).length !== 0
              ),
              addedBy: { name: userName, userId: userId },
              vendorSource: "MARKETPLACE",
            };
            return supplierObj;
          })
        );
        dispatch(
          addVendorsToRfq({
            rfqId,
            suppliers,
            requesterName: userName,
            requestedBy: userEmail,
            senderEmail
          })
        );
        setAddVendorsLoader(false);
        handleSliderClose();
        setSelectedRows([]);
        navigate(`/rfqs/${rfqId}/Vendors`);
      } catch (error) {
        console.error("Error fetching user contacts:", error);
        setAddVendorsLoader(false);
        setAddNewVendorError(true);
        setTimeout(() => {
          setAddNewVendorError(false);
        }, 3000);
      }
    }
  };
  // console.log(data);

  useEffect(() => {
    //when user clr filter or any type of changes with vendors data then selected goes blank
    // setSelectedRows([]);
    const pageNum = start > 0 ? start / 60 + 1 : 1;
    setCurrentPage(pageNum);
    handleOpenBusinessInfoDrawerClose();
  }, [data]);

  useEffect(() => {
    const revealedMap = {};
    viewedSupplierIds.forEach(id => revealedMap[id] = true);

    setRevealedContacts(revealedMap);
    setRevealedEmails(revealedMap);
  }, [viewedSupplierIds]);

  useEffect(() => {
    if (userId && entityId) {
      dispatch(fetchContactViewStatus(userId, entityId));
    }
  }, [userId, entityId]);

  const toolbarSummary = totalItems >= 1 ? (
    <div className="min-w-0 space-y-2">
      <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-[#555548]">
        <span>
          {`Showing ${(currentPage - 1) * 60 + 1} to ${(currentPage - 1) * 60 + searchResult?.results?.length
            } of ${searchResult?.numFound} ${searchResult?.results?.length > 1 ? "total vendors" : "total vendor"}`}
        </span>
        <span className="rounded-full border border-[#FAD7C4] bg-[#FFF4EE] px-2.5 py-1 font-bold text-[#E95420]">
          {resultLabel}
        </span>
        <span className="rounded-full border border-[#E4E7EE] bg-[#F8F8F2] px-2.5 py-1 font-semibold text-[#303026]">
          Location: {regionString || "Pan India"}
        </span>
        {loading && (
          <span className="inline-flex items-center gap-1 rounded-full bg-[#EEF6FF] px-2.5 py-1 text-[#1D4ED8]">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#1D4ED8]" />
            Updating results...
          </span>
        )}
      </div>

      {hasActiveUserFilters && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#7A7D86]">
            Applied filters
          </span>
          {activeFilterFacets.flatMap((facet) =>
            (facet?.values || []).map((value) => (
              <button
                key={`${facet.facet}-${value}`}
                type="button"
                onClick={() => handleRemoveNetworkFilter(facet.facet, value)}
                className="inline-flex items-center gap-1 rounded-full border border-[#F7B99D] bg-[#FFF9F5] px-2.5 py-1 text-[11px] font-semibold text-[#B43A12] transition hover:bg-[#FFE8DA]"
                title="Remove filter"
              >
                {chipFilterValue(facet.facet, value)}
                <span className="text-sm leading-none">x</span>
              </button>
            ))
          )}
          <button
            type="button"
            onClick={handleClearNetworkFilters}
            className="text-[11px] font-semibold text-[#0057D9] underline underline-offset-2 hover:text-[#003F9E]"
          >
            Clear all filters
          </button>
        </div>
      )}
    </div>
  ) : null;

  const toolbarActions = (
    <>
      {isSliderView && <p className="rounded-full bg-[#F8F8F2] px-3 py-1 text-xs font-medium text-[#555548]">
        Invite Limit: {maxLimit} | Invited: {invitedVendors?.length} | Remaining: {remainingLimit}
      </p>}

      {!isSliderView && (
        <p className="rounded-full bg-[#F8F8F2] px-3 py-1 text-xs font-medium text-[#555548]">
          Contact Limit: {contactLimit} | Viewed: {contactViewed} | Remaining: {Math.max(contactLimit - contactViewed, 0)}
        </p>
      )}

      {!selectionOnly && selectedRows?.length > 0 && <div className="relative flex" >
        <button
          className="rounded-md border border-[#1F1E29] px-4 py-2 text-xs font-medium text-[#1F1E29] transition-shadow hover:shadow-md"
          onClick={handleSelectedVendorsClick}
        >
          Selected Vendors
        </button>
        {selectedRows?.length > 0 && (
          <span className="absolute -mt-2 -mr-1 top-0 right-0 h-5 w-5 bg-red-500 text-white rounded-full flex items-center justify-center text-xs">
            {selectedRows?.length}
          </span>
        )}
      </div>}

      {!isSliderView && !loading ? null : selectionOnly ? null : (
        <div className="flex flex-col items-center text-xs">
          {!loading && <button
            disabled={!selectedRows?.length >= 1 || addVendorsLoader}
            onClick={handleAddVendorsToRfq}
            className={`m-auto rounded-md px-4 py-2
        ${selectedRows?.length >= 1
                ? "bg-[#1F1E29] text-white hover:bg-black"
                : "bg-gray-300 text-gray-100"
              }
        ${addVendorsLoader ? "opacity-50 cursor-not-allowed" : ""}
        `}
          >
            {addVendorsLoader ? <Loading /> : "Invite Vendors"}
          </button>}
          {addNewVendorError && (
            <p className="text-red-500 text-xs">
              something Wrong in selected data
            </p>
          )}
        </div>
      )}
    </>
  );

  const localToolbar = (
    <div className="sticky top-0 z-20 mb-3 flex shrink-0 flex-wrap items-center justify-between gap-3 rounded-2xl border border-[#E8E8E0] bg-white/95 px-3 py-2 shadow-sm backdrop-blur">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {!selectionOnly && typeof onToggleFilters === "function" && (
          <button
            type="button"
            onClick={onToggleFilters}
            className={`inline-flex shrink-0 items-center gap-2 rounded-xl border px-4 py-2 text-sm font-semibold transition ${
              showFilters
                ? "border-[#E95420] bg-[#FFF4EE] text-[#B43A12]"
                : "border-[#DADAD0] bg-white text-[#303026] hover:border-[#E95420] hover:text-[#B43A12]"
            }`}
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 5h18M6 12h12M10 19h4"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
            Filters
          </button>
        )}
        <div className="min-w-0 flex-1">{toolbarSummary}</div>
      </div>
      <div className="flex items-center gap-3">{toolbarActions}</div>
    </div>
  );

  return (
    <>
      <div className="flex h-full min-h-0 flex-col">
      {toolbarSummaryPortalTarget && toolbarSummary
        ? createPortal(toolbarSummary, toolbarSummaryPortalTarget)
        : null}
      {toolbarActionsPortalTarget
        ? createPortal(toolbarActions, toolbarActionsPortalTarget)
        : null}
      {!toolbarSummaryPortalTarget && !toolbarActionsPortalTarget && localToolbar}
      <Snackbar open={snackbarOpen} autoHideDuration={2000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {loading && (
        <div className="flex min-h-0 flex-1 items-center justify-center rounded-2xl border border-[#E8E8E0] bg-white/90">
          <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10"></div>
        </div>
      )}
      {!loading && totalItems == 0 && (
        <div className="flex min-h-0 flex-1 items-center justify-center rounded-2xl border border-[#E8E8E0] bg-[linear-gradient(180deg,#FFF9F5_0%,#FFFFFF_56%)] p-8 text-center shadow-sm">
          <div className="max-w-xl">
            <img
              src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
              className="mx-auto mb-5 h-[96px] w-[102px]"
              alt="No search results"
            />
            <div className="mb-3 flex flex-wrap justify-center gap-2">
              <span className="rounded-full border border-[#FAD7C4] bg-[#FFF4EE] px-3 py-1 text-xs font-bold text-[#E95420]">
                {resultLabel}
              </span>
              <span className="rounded-full border border-[#E4E7EE] bg-white px-3 py-1 text-xs font-semibold text-[#303026]">
                Location: {regionString || "Pan India"}
              </span>
            </div>
            <p className="text-base font-bold text-[#303026]">
              No vendors found with these filters
            </p>
            <p className="mt-2 text-sm text-[#6B6B5F]">
              Remove an applied filter, try Pan India, or go back to choose another category.
            </p>
            <div className="mt-5 flex flex-wrap justify-center gap-3">
              {hasActiveUserFilters && (
                <button
                  type="button"
                  onClick={handleClearNetworkFilters}
                  className="rounded-full bg-[#1F1E29] px-5 py-2 text-sm font-semibold text-white transition hover:bg-black"
                >
                  Clear filters
                </button>
              )}
              {typeof onToggleFilters === "function" && !showFilters && (
                <button
                  type="button"
                  onClick={onToggleFilters}
                  className="rounded-full border border-[#FD6600] bg-[#FFF4EE] px-5 py-2 text-sm font-semibold text-[#B43A12] transition hover:bg-[#FFE8DA]"
                >
                  Show filters
                </button>
              )}
              {showRegionInSummary && (
                <button
                  type="button"
                  onClick={handleTryPanIndia}
                  className="rounded-full border border-[#C8D7F5] bg-[#EEF6FF] px-5 py-2 text-sm font-semibold text-[#1D4ED8] transition hover:bg-[#E0EEFF]"
                >
                  Try Pan India
                </button>
              )}
              {!selectionOnly && (
                <button
                  type="button"
                  onClick={() => navigate("/neevay-network")}
                  className="rounded-full border border-[#DADAD0] bg-white px-5 py-2 text-sm font-semibold text-[#303026] transition hover:border-[#FD6600] hover:text-[#B43A12]"
                >
                  Back to category search
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {!loading && totalItems >= 1 && (
        <div className="relative flex min-h-0 flex-1 w-full flex-col overflow-hidden rounded-2xl border border-[#E8E8E0] bg-white shadow-sm">
          <div className="neevay-network-table-scroll min-h-0 flex-1 overflow-auto rounded-2xl">
            <table className="w-full table-auto border-separate border-spacing-0 text-left text-xs text-gray-500 dark:text-gray-400">
              <thead className="sticky top-0 z-10 h-12 bg-gray-50 text-xs text-[#374151]">
                <tr>
                  {/* {isSliderView && (
                    <th
                      scope="col"
                      className="sticky left-0 top-0 z-10 p-4 bg-gray-50"
                    >
                      <div className="w-4"></div>
                    </th>
                  )} */}
                  <th
                    scope="col"
                    className="neevay-network-sticky-cell sticky left-0 top-0 z-[6] w-[280px] min-w-[280px] rounded-tl-md border-b border-gray-200 bg-gray-50 text-left font-medium text-[#374151]"
                  >
                    <div
                      className="flex items-center gap-4 bg-gray-50 px-4 py-3"
                      style={{
                        boxShadow: "5px -2px 13.1px 0px rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      <p className="px-2 py-1 text-xs">Business Name</p>
                    </div>
                  </th>
                  {fields.slice(1).map((field, index) => (
                    <th
                      scope="col"
                      key={field.key}
                      className={getClassName(index, fields.length, field.key)}
                    >
                      {field.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((vendor) => (
                    <tr
                      key={vendor.supplierId}
                      className={`group border-b border-gray-100 bg-white text-xs transition hover:bg-[#FFF9F5]
                        ${!isVendorSelectable(vendor) && isRestrictionEnabled ? "opacity-60" : ""}
                      `}                  
                      >
                    {/* {console.log("this  is a data of vendor", vendor)} */}
                    <td className="neevay-network-sticky-cell sticky left-0 z-[4] w-[280px] min-w-[280px] border-b border-gray-100 bg-white text-xs transition group-hover:bg-[#FFF9F5]">
                      <div
                        className="absolute bottom-0 left-0 top-0 flex w-[280px] items-center gap-4 truncate bg-white px-4 group-hover:bg-[#FFF9F5]"
                        style={{
                          boxShadow: "5px 0 13.1px 0px rgba(0, 0, 0, 0.05)",
                          zIndex: 1,
                        }}
                      >
                        {/* {isSliderView && ( */}
                        {!invitedVendors?.some(
                          (supplier) =>
                            supplier?.supplierId === vendor.supplierId) ?
                          <div className="flex items-center">

                            {!isVendorSelectable(vendor) && isRestrictionEnabled ? (
                              <Tooltip
                                title="This vendor is restricted and cannot be selected"
                                arrow
                                placement="top"
                              >
                                <span>
                                  <input
                                    type="checkbox"
                                    disabled
                                    className="w-4 h-4 bg-gray-100 border-gray-300 rounded opacity-40 cursor-pointer"
                                  />
                                </span>
                              </Tooltip>

                            ) : (

                              <input
                                id="checkbox-table-search-1"
                                type="checkbox"
                                onChange={(e) => handleSelectRow(e, vendor)}
                                disabled={invitedVendors?.some(
                                  (supplier) => supplier?.supplierId === vendor?.supplierId
                                )}
                                checked={selectedRows.some(
                                  (selectedRow) =>
                                    getMarketplaceVendorKey(selectedRow) ===
                                    getMarketplaceVendorKey(vendor)
                                )}
                                onClick={(e) => e.stopPropagation()}
                                className="w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500"
                              />

                            )}

                            <label htmlFor="checkbox-table-search-1" className="sr-only">
                              checkbox
                            </label>

                          </div> : <div className="w-4"></div>}
                        {/* )} */}
                        <Drawer
                          values={vendor}
                          handleOpenBusinessInfoDrawerOpen={
                            handleOpenBusinessInfoDrawerOpen
                          }
                          invitedVendors={invitedVendors}
                        />
                      </div>
                    </td>
                    {fields.slice(1).map((field, index) => {
                      const Component = componentRegistry(
                        field.component,
                        handleOpenBusinessInfoDrawerOpen,
                        {
                          ...field.componentProps,
                          values: vendor[field.mappedField],
                          title: field.title,
                          vendor: vendor,
                          isContactRevealed: revealedContacts[vendor.supplierId],
                          isEmailRevealed: revealedEmails[vendor.supplierId],
                          onRevealContact: handleViewContact,
                          onRevealEmail: handleViewContact,
                        }
                      );
                      return (
                        <td
                          key={field.key}
                          className={`border-b border-gray-100 px-4 py-3 text-left text-xs text-gray-700 transition hover:bg-[#FFF9F5] ${getColumnWidthClass(field.key)}`}
                        // className={`hover:bg-blue-50 ${
                        //   !index
                        //     ? `bg-inherit sticky ${
                        //         isSliderView ? "left-10" : "left-0"
                        //       } z-10`
                        //     : "text-black px-6 py-4"
                        // }`}
                        >
                          {Component}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
            <style>
              {`
                .neevay-network-table-scroll::-webkit-scrollbar {
                  height: 6px;
                  width: 6px;
                }

                .neevay-network-table-scroll::-webkit-scrollbar-thumb {
                  background-color: #949494; 
                }

                .neevay-network-sticky-cell {
                  position: sticky;
                }

                .neevay-network-sticky-cell::after {
                  content: "";
                  position: absolute;
                  top: 0;
                  right: -10px;
                  width: 10px;
                  height: 100%;
                  z-index: 2;
                  pointer-events: none;
                  background: linear-gradient(90deg, rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0));
                }

                .neevay-network-table-scroll button {
                  text-align: left;
                }
              `}
            </style>
          </div>
          <div className="sticky bottom-0 z-20 shrink-0 border-t border-[#ECECE3] bg-white">
            <PaginationSection
              totalPages={totalPages}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </div>
          {/* <StaticPopup
            openModal={showAddVendorPopup}
            handleClose={() => setShowAddVendorPopup(false)}
            // header={`Add Vendor to ${directoryName} Directory`}
            header={`Add Vendor to Internal Vendors`}
          >
            <div className="flex flex-col gap-3 mt-8">
              <label className="font-bold text-xs text-[#222222]">
                Tag Vendor{" "}
                <span className="font-light italic text-xs text-black ml-2">
                  {"(Optional)"}
                </span>
              </label>
              <input
                id="tagVendor"
                type="text"
                value={tagVendor}
                onChange={handleInputChange}
                className="w-[244px] px-3 py-2 border border-[#9C9C9C] bg-[#EEEEEE] rounded-md "
              />
            </div>
            <button
              className="bg-[#1A56DB] px-6 py-3 max-w-32 mt-auto rounded hover:bg-blue-800"
              onClick={() => {
                setAddVendorWithTagsLoading(true);
                handleAddVendorToCD();
              }}
            >
              <p className="font-bold text-xs text-white">
                {addVendorWithTagsLoading ? <Loading /> : "Add Vendor"}
              </p>
            </button>
          </StaticPopup> */}
          <BusinessInfoDrawer
            handleOpenBusinessInfoDrawerClose={
              handleOpenBusinessInfoDrawerClose
            }
            values={businessInfo}
            openBusinessInfoDrawer={openBusinessInfoDrawer}
            showMarketplaceContacts
          />

          <AddCategoryPopUp
            open={showAddCategoryPopup}
            onClose={() => {
              if (!addVendorWithTagsLoading) {
                setShowAddCategoryPopup(false);
                setAddCategoryError({ status: false, message: "" });
              }
            }}
            onApply={handleAddVendorToCD}
            loading={addVendorWithTagsLoading}
            selectedVendors={selectedRows}
            showError={addCategoryError}
          />


          <SelectedVendorsDrawerNN
            openDrawer={openDrawer}
            handleCloseDrawer={handleCloseDrawer}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            handleAddVendorsToRfq={handleAddVendorsToRfq}
            handleSelectedVendorsClick={handleSelectedVendorsClick}
            handleAddVendorToCD={handleClickAddToCompanyDirectory}
            isSliderView={isSliderView}
            selectedRowsLength={selectedRows.length}
          />
        </div >
      )}
      </div>
    </>
  );
};

export default Table;


